import { compareAsc } from 'date-fns'

import { formatDate } from '../../../../../../helpers/date/parser'
import legacyParse from '../../../../../../helpers/legacyDateParser'
import doesShiftFallOnWorkDay from '../../../../../../services/ShiftService/doesShiftFallOnWorkDay'
import { ScheduleShift } from '../../../../../entities/Shift/Shift'

export function filterShiftsByDays(shifts: ScheduleShift[], day: Date): ScheduleShift[] {
    return shifts
        .filter((shift) => doesShiftFallOnWorkDay(shift, day))
        .sort((a, b) => compareAsc(legacyParse(a.period.start), legacyParse(b.period.start)))
}

export function getHeader(day: Date) {
    return formatDate(new Date(day), 'EEEEEE')
}
